import { makeStyles } from "tss-react/mui";
import { Grid, Tabs, Tab, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ResponsivePage from "../../common/core/ResponsivePage";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useState } from "react";
import config from "../../../config";
import MissionRequestDialog from "./missionrequest/MissionRequestDialog";
import NewRequestsSection from "./subpages/received/NewRequestsSection";
import AcceptedRequestsSection from "./subpages/received/AcceptedRequestsSection";
import RejectedRequestsSection from "./subpages/received/RejectedRequestsSection";
import AllRequestsSection from "./subpages/received/AllRequestsSection";
import { useEmployee } from "../../../providers/EmployeeProvider";
import { useDevice } from "../../../providers/DeviceProvider";

const useStyles = makeStyles()(
  (theme) => ({
    tabs: {
      marginBottom: theme.spacing(3),
      borderBottom: `1px solid ${theme.palette.divider}`
    },
    tabsSlim: {
      borderBottom: `1px solid ${theme.palette.divider}`
    }
  })
);

export default function ReceivedMissionRequestsPage() {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { tabId } = useParams();
  const [requestId, setRequestId] = useState("");
  const { openRequests } = useEmployee();
  const { slim } = useDevice();

  const navigate = useNavigate();
  const onTabChange = useCallback((_, val) => navigate(!!tabId ? `../${val}` : `./${val}`, { relative: "path", replace: true }), [navigate, tabId]);

  const onOpenDialog = useCallback((params, ev) => {
    setRequestId(params.id);
  }, [navigate, tabId]);

  const onCloseDialog = useCallback(() => {
    setRequestId("");
  });

  return (
    <ResponsivePage
      title={t("missionRequests:title")}
      maxWidth={config.pageSize.large}
    >
      {
        !slim ? (
          <Grid item xs={12}>
            <Typography variant="body1" color="textSecondary">{t("missionRequests:description")}</Typography>
          </Grid>
        ) : null
      }

      <Grid item xs={12}>
        <Tabs className={slim ? classes.tabsSlim : classes.tabs} value={tabId || "new"} onChange={onTabChange} variant="scrollable" scrollButtons="auto">
          <Tab value="new" label={`${t("missionRequests:newRequestsTab")} (${openRequests.length})`} />
          <Tab value="accepted" label={t("missionRequests:acceptedRequestsTab")} />
          <Tab value="rejected" label={t("missionRequests:rejectedRequestsTab")} />
          <Tab value="all" label={t("missionRequests:allRequestsTab")} />
        </Tabs>
      </Grid>

      {
        !tabId || tabId === "new" ? (
          <NewRequestsSection onRowClick={onOpenDialog} />
        ) : tabId === "accepted" ? (
          <AcceptedRequestsSection onRowClick={onOpenDialog} />
        ) : tabId === "rejected" ? (
          <RejectedRequestsSection onRowClick={onOpenDialog} />
        ) : (
          <AllRequestsSection onRowClick={onOpenDialog} />
        )
      }

      {!!requestId ? (
        <MissionRequestDialog entityId={requestId} onClose={onCloseDialog} openButton />
      ) : null}

    </ResponsivePage>
  );
}
